<template>
  <div style=" width: 300px;margin: 0 auto;">
    <div style="text-align: right;">
      <span class="btn btn-default" @click="updateOrder">Update</span>
    </div>
    <div v-for="(item, index) in items" :key="item.id" style="padding: 10px;margin: 5px 0;background-color: #f0f0f0;border: 1px solid #ccc;cursor: move;" draggable="true"
      @dragstart="dragStart(index, $event)" @dragover.prevent @dragenter.prevent @drop="drop(index, $event)">
      <button class="glyphicon glyphicon-arrow-up" @click="moveUp(index)">Up</button>
      <button class="glyphicon glyphicon-arrow-down" @click="moveDown(index)">Down</button>
      {{ item.name }}
    </div>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      items: [],
      draggedItemIndex: null,
    };
  },
  methods: {
    dragStart(index, event) {
      this.draggedItemIndex = index;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index);
    },
    drop(index, event) {
      event.preventDefault();
      const draggedIndex = this.draggedItemIndex;
      if (draggedIndex !== index) {
        const items = [...this.items];
        const [reorderedItem] = items.splice(draggedIndex, 1);
        items.splice(index, 0, reorderedItem);
        this.items = items;
      }
      this.draggedItemIndex = null;
      console.log('items ordered:', this.items);
    },
    moveUp(index) {
      if (index > 0) {
        this.moveItem(index, index - 1);
      }
    },
    moveDown(index) {
      if (index < this.items.length - 1) {
        this.moveItem(index, index + 1);
      }
    },
    moveItem(fromIndex, toIndex) {
      const items = [...this.items];
      const [movedItem] = items.splice(fromIndex, 1);
      items.splice(toIndex, 0, movedItem);
      this.items = items;
      console.log('items ordered:', this.items);
    },
    updateOrder() {
      // send the updated order to the server
      this.$emit('updateOrder', this.items);
    }
  },
  mounted() {
    this.items = this.categories.map((category, index) => ({ ...category }));
  }
};
</script>
